import { action } from 'app/actions';

export const GET_INFO = 'units/GET_INFO';
export const getInfo = payload => action(GET_INFO, { payload });
